import React, { useEffect, useRef, useState } from "react";
import { IconButton, Tooltip } from "@mui/material";
import { Edit as IconEdit } from "@mui/icons-material";
import { withSnackbar } from "notistack";
import { Close as IconClose } from "@mui/icons-material";

import Btn from "components/Custom/Btn";
import ExcelGrid from "components/Custom/ExcelGrid";
import Loader from "components/Custom/Loader";
import RadioBtn from "components/Custom/RadioBtn";
import TxtRow from "components/Custom/TxtRow";
import AutoComplete from "components/Custom/AutoComplete";
import UiDialog from "components/Custom/UiDialog";

import { COMMON_JS } from "common/scripts";
import { API_CONFIG, CONFIG, DEFAULTS, FORMATS, NOTIFY } from "common/config";
import { DateFunctions } from "common/datefunctions";
import { COLORS } from "common/colors";
import {
  ERRORS,
  LABELS,
  SUB_TITLES,
  SUCCESS,
  TITLES,
  WARNINGS,
} from "common/lables";

import { USER_APIs } from "apihandlers/user";
import Area from "components/Masters/Area";
import { GEO_APIs } from "apihandlers/geography";
import { PRODUCT_APIs } from "apihandlers/product";
import TxtBox from "components/Custom/TxtBox";
import { AUTH_APIs } from "apihandlers/auth";
import SkeletonBox from "components/Custom/SkeletonBox";

import { MASTER_APIs } from "apihandlers/master";
import { CRM_APIs } from "apihandlers/crm";

const thumbnailImg = require("assets/images/pdf.png");

const LeadProfileImport = (props: any) => {
  const { setDashMenu } = props;

  const model = [
    {
      id: "Scheme Engine Sep22 v1",
      label: "Scheme Engine Sep22 v1",
    },
    {
      id: "Scheme Engine Sep22 v2",
      label: "Scheme Engine Sep22 v2",
    },
  ];

  const [rows, setRows] = useState<any>(null);
  const [manageDialog, setManageDialog] = useState<boolean>(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [loading, setLoading] = useState(true);
  const [isSubmit, setIsSubmit] = useState(false);
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);
  const [mandatoryLoadResults, setMandatoryLoadResults] = useState<any[]>([]);
  const [uploading, setUploading] = useState<boolean>(false);
  const [leadProfileFile, setLeadProfileFile] = useState([]);

  // const [model, setUsers] = useState([]);
  const [product, setProduct] = useState([]);
  const [scheme, setScheme] = useState<any>(
    selectedRow.messages ? selectedRow.messages : []
  );

  const modelRef: any = useRef(null);
  const productRef: any = useRef(null);
  const schemeRef: any = useRef(null);
  const columns = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      type: "number",
      width: "5%",
      align: "center",
      headerAlign: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "file",
      name: LABELS.FILE,
      width: "30%",
      editable: false,
      // sortable: true,
      align: "center",
      type: "html",
      // searchable: true,
    },
    {
      key: "date",
      name: LABELS.DATE,
      width: "30%",
      editable: false,
      sortable: true,
      align: "center",
      type: "text",
      searchable: true,
    },
    {
      key: "executive",
      name: LABELS.EXECUTIVE,
      width: "35%",
      editable: false,
      sortable: true,
      align: "center",
      type: "text",
      searchable: true,
    },
  ];

  useEffect(() => {
    if (loading) {
      getRows();
    }
  }, [loading]);

  // const getRows = () => {
  //   const args = {
  //     pageNo: 1,
  //     pageLength: DEFAULTS.PAGE_LENGTH,
  //   };
  //   MASTER_APIs.getVehicleChecks(args).then((res: any) => {
  //     const response: any = res.response;
  //     const { status } = res;
  //     if (status === 200) {
  //       let list = response.records;
  //       for (let i = 0; i < list.length; i++) {
  //         list[i]["slNo"] = i + 1;
  //         if (list[i]["activeStatus"]) {
  //           list[i]["activeStatus"] = "Yes";
  //         } else {
  //           list[i]["activeStatus"] = "No";
  //         }
  //       }
  //       setRows(list);
  //       setLoading(false);
  //     }
  //   });
  // };
  const reloadGrid = () => {
    setRows(null);
    getRows();
  };

  const getRows = () => {
    const args = {
      pageNo: 1,
      pageLength: DEFAULTS.PAGE_LENGTH,
    };
    CRM_APIs.getLeadProfileImport(args).then((res: any) => {
      const response: any = res.response;
      console.log("response", response);
      const { status } = res;
      if (status === 200) {
        let list = response.records;
        for (let i = 0; i < list.length; i++) {
          list[i]["slNo"] = i + 1;
          if (list[i]["activeStatus"]) {
            list[i]["activeStatus"] = "Yes";
          } else {
            list[i]["activeStatus"] = "No";
          }
          let fileUrl = "http://192.168.0.109:7001//" + list[i].file;
          list[i].file = (
            <div>
              <img
                alt=""
                src={fileUrl}
                width={100}
                height={50}
                onClick={() => {
                  window.open(fileUrl, "_blank");
                }}
              />
            </div>
          );
        }
        setRows(list);
        setLoading(true);
      }
    });
  };

  const onUploadFile = (e: any, f: any) => {
    console.log("onUploadFile: ", e, f);
    const file: any = e.target.files[0];
    if (file.size / 1024 / 1024 > CONFIG.MAX_FILE_SIZE) {
      COMMON_JS.showNotify(props, NOTIFY.WARNING, WARNINGS.FILE_SIZE_EXCEEDED);
      return;
    }
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      let base64: any = reader.result;
      setLeadProfileFile(null);
      setUploading(true);
      uploadFile(file, base64).then((res) => {
        console.log("RES", res);

        setLeadProfileFile([res]);
        setUploading(false);
      });
    };
    reader.onerror = (error) => {
      console.log("uploadFile: Error:", error);
    };
  };

  const uploadFile = async (file: any, base64 = "") => {
    const args = {
      recordRefId: 1,
      file: {
        name: file.name,
        data: base64.replace("data:", "").replace(/^.+,/, ""),
        type: file.type,
        mimeType: file.name.split(".")[1],
        size: file.size,
      },
      category: "storevisit",
    };
    let fileInfo = null;
    try {
      const res = await AUTH_APIs.fileUpload(args);
      const response: any = res.response;
      if (res.status === 200) {
        fileInfo = response;
        fileInfo["mimeType"] = args.file.mimeType;
        (document.getElementById("uploadFile") as HTMLInputElement).value =
          null;
      }
    } catch (error) {}
    return fileInfo;
  };

  const manageDocument = () => {
    // Validations;
    let errors = [];
    if (leadProfileFile.length === 0) {
      errors.push({
        id: "leadProfileFile",
        msg:
          "<span class='bold'>" +
          LABELS.UPLOAD_FILE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }

    setMandatoryResults(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }

    const args = {
      id: selectedRow.id || -1,
      file: leadProfileFile,
    };
    console.log("args", args);
    setLeadProfileFile([]);

    return;
    setIsSubmit(true);
    MASTER_APIs.manageComment(args).then((res) => {
      setIsSubmit(false);
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        setSelectedRow({});
        setManageDialog(false);
        reloadGrid();
        setLeadProfileFile([]);
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
  };
  console.log("Page: LeadProfileImport:", leadProfileFile);

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu("")}>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => setDashMenu(LABELS.HOME)}>{LABELS.CRM} </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.LEAD_PROFILE_IMPORT}</li>
        </ul>
        <h4>{TITLES.LEAD_PROFILE_IMPORT}</h4>
        <p>{SUB_TITLES.LEAD_PROFILE_IMPORT}</p>
      </div>
      <div className=" flexRowJustify width30" style={{ height: "7%" }}>
        <div className="formGroup width70 required">
          <label>{LABELS.UPLOAD_FILE + " *"}</label>
          <TxtBox
            type={"file"}
            id={"uploadFile"}
            accept="image/*,.pdf"
            onChange={onUploadFile}
            required={true}
          />
        </div>

        <div
          style={{
            padding: "1.5rem 0rem 3rem 0rem",
          }}
        >
          <Btn
            text={LABELS.UPLOAD}
            onClick={manageDocument}
            bgColor={COLORS.SAVE_GREEN}
          />
        </div>
      </div>
      {/* mandatoryResults */}
      {mandatoryResults.length > 0 && (
        <div className="mandatoryBox">
          <ul>
            {mandatoryResults.map((m) => {
              return (
                <li>
                  <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                </li>
              );
            })}
          </ul>
        </div>
      )}
      <div
        className="formGroup"
        style={{
          width: "38%",
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          paddingLeft: "3rem",
        }}
      >
        {leadProfileFile &&
          leadProfileFile.map((u, i) => {
            return (
              <div className="thumbnailBox width20" key={"storefile-" + i}>
                <IconButton
                  className="thumbnailBoxIcon"
                  onClick={() => {
                    const list = leadProfileFile.filter((a, j) => j !== i);
                    setLeadProfileFile(list);
                  }}
                >
                  <IconClose />
                </IconButton>
                <img
                  onClick={() =>
                    window.open(API_CONFIG.STATIC_URL + u.path, "_blank")
                  }
                  src={
                    u.mimeType === "pdf"
                      ? thumbnailImg
                      : API_CONFIG.STATIC_URL + u.path
                  }
                  className="responsive cursor"
                  width={"100rem"}
                  height={"100rem"}
                  alt={"file"}
                />
              </div>
            );
          })}
        {uploading && (
          <div className="thumbnailBox width20">
            <SkeletonBox height={100} />
          </div>
        )}
      </div>

      <div className="grid excelGridWrapper">
        {loading === true ? (
          rows && (
            <ExcelGrid
              id={"leadProfileImport"}
              height={window.innerHeight * 0.8}
              cols={columns}
              rows={rows}
              exportOption={true}
              newRowOption={false}
              exportName={LABELS.LEAD_PROFILE_IMPORT}
              onReload={reloadGrid}
            />
            // ) : (
            //   <div className="flexRowCenter">
            //     <Loader />s
            //   </div>
          )
        ) : (
          <div className="flexRowCenter">
            <Loader />
          </div>
        )}
      </div>
    </React.Fragment>
  );
};
export default withSnackbar(LeadProfileImport);
